import {Box} from "@mui/system";
import GorgiasSection from './GorgiasSection';
import SalesforceSection from "./SalesforceSection";
import KustomerSection from "./KustomerSection";
import TrendsSection from "./TrendsSection";
import TrendsOnlyDataSourceDetails from "./TrendsOnlyDataSourceDetails";

export default function DataSourceDetails({handle, trendsHandle, isTrendsOnly, label, organizationId, organizationTrendsId}) {
    const isSalesforce = () => {
        return handle.msgSourceName?.toLowerCase()?.includes('salesforce');
    };

    if (isTrendsOnly) {
        return (
            <TrendsOnlyDataSourceDetails
                trendsHandle={trendsHandle}
                label={label}
                organizationId={organizationId}
                organizationTrendsId={organizationTrendsId}
            />
        );
    }

    return (
        <Box>
            { trendsHandle && (<TrendsSection trendsHandle={trendsHandle} label={label} />) }
            { handle.gorgias && (<GorgiasSection handle={handle} label={label} />) }
            { handle.kustomer && (<KustomerSection handle={handle} label={label} />) }
            { isSalesforce() && (<SalesforceSection handle={handle} label={label} />) }
        </Box>
    );
}
